export default {"socialButton":"zup15"};